/**
 * Converts FAQ-style collection SEO outro copy into an accordion.
 *
 * The metafield remains authorable as ordinary HTML: a contiguous group of
 * question paragraphs (ending in "?") followed by answer elements is treated
 * as FAQ copy. At least two pairs are required so regular prose is not changed.
 */
(function () {
  'use strict';

  var contentSelector = '[data-clp-accordion-content]';
  var instanceCount = 0;

  function hasText(element) {
    return element.textContent.trim().length > 0;
  }

  function isQuestion(element) {
    return element.tagName === 'P' && /\?\s*$/.test(element.textContent.trim());
  }

  function findFaqGroups(elements) {
    var groups = [];
    var index = 0;

    while (index < elements.length) {
      if (!isQuestion(elements[index]) || !elements[index + 1] || isQuestion(elements[index + 1])) {
        index += 1;
        continue;
      }

      var pairs = [];
      var cursor = index;

      while (
        cursor + 1 < elements.length &&
        isQuestion(elements[cursor]) &&
        !isQuestion(elements[cursor + 1])
      ) {
        pairs.push({
          question: elements[cursor],
          answer: elements[cursor + 1]
        });
        cursor += 2;
      }

      if (pairs.length >= 2) {
        groups.push(pairs);
        index = cursor;
      } else {
        index += 1;
      }
    }

    return groups;
  }

  function createIcon() {
    var icon = document.createElement('span');
    icon.className = 'clp-accordion__icon';
    icon.setAttribute('aria-hidden', 'true');
    return icon;
  }

  function createAccordion(pairs, instanceId) {
    var accordion = document.createElement('div');
    accordion.className = 'clp-accordion';

    pairs.forEach(function (pair, pairIndex) {
      var item = document.createElement('div');
      var button = document.createElement('button');
      var title = document.createElement('span');
      var panel = document.createElement('div');
      var panelInner = document.createElement('div');
      var buttonId = 'clp-accordion-button-' + instanceId + '-' + pairIndex;
      var panelId = 'clp-accordion-panel-' + instanceId + '-' + pairIndex;

      item.className = 'clp-accordion__item';

      button.className = 'clp-accordion__header';
      button.type = 'button';
      button.id = buttonId;
      button.setAttribute('aria-expanded', 'false');
      button.setAttribute('aria-controls', panelId);

      title.className = 'clp-accordion__title';
      title.innerHTML = pair.question.innerHTML;

      panel.className = 'clp-accordion__content';
      panel.id = panelId;
      panel.setAttribute('role', 'region');
      panel.setAttribute('aria-labelledby', buttonId);
      panel.hidden = true;

      panelInner.className = 'clp-accordion__content-inner';
      panelInner.appendChild(pair.answer);

      button.appendChild(title);
      button.appendChild(createIcon());
      panel.appendChild(panelInner);
      item.appendChild(button);
      item.appendChild(panel);
      accordion.appendChild(item);

      pair.question.remove();
    });

    accordion.addEventListener('click', function (event) {
      var button = event.target.closest('.clp-accordion__header');
      if (!button || !accordion.contains(button)) return;

      var selectedItem = button.closest('.clp-accordion__item');
      var wasOpen = button.getAttribute('aria-expanded') === 'true';

      accordion.querySelectorAll('.clp-accordion__item').forEach(function (item) {
        var itemButton = item.querySelector('.clp-accordion__header');
        var itemPanel = item.querySelector('.clp-accordion__content');
        var shouldOpen = item === selectedItem && !wasOpen;

        item.classList.toggle('is-active', shouldOpen);
        itemButton.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
        itemPanel.hidden = !shouldOpen;
      });
    });

    return accordion;
  }

  function initCollectionAccordions() {
    document.querySelectorAll(contentSelector).forEach(function (content) {
      if (content.hasAttribute('data-clp-accordion-initialized')) return;
      content.setAttribute('data-clp-accordion-initialized', 'true');

      var elements = Array.prototype.filter.call(content.children, hasText);
      var groups = findFaqGroups(elements);

      groups.forEach(function (pairs) {
        var insertionMarker = document.createComment('clp-accordion');
        content.insertBefore(insertionMarker, pairs[0].question);
        instanceCount += 1;
        var accordion = createAccordion(pairs, instanceCount);
        content.replaceChild(accordion, insertionMarker);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionAccordions);
  } else {
    initCollectionAccordions();
  }

  document.addEventListener('shopify:section:load', initCollectionAccordions);
})();
